import { CalenderApi } from "../../API/CalenderApi";
import { ZensoryCloudFunctionNames } from "../../Data/Models/zensory_api";
import { getFirebaseHelper } from "../../Util/FirebaseHelper";
import { LOGGER, LogLevel } from "../../Util/Logger";

export interface Events {
  eventId: string;
  updateData: {
    sessionType: string;
    start: {
      dateTime: string;
    };
    durationMinutes: number;
  };
}
export class CalenderSchedules implements CalenderApi {
  async calenderLogin(request: {
    clientId: string;
    userId: string;
    redirectUri: string;
  }): Promise<any> {
    const payload = {
      clientId: request.clientId,
      userId: request.userId,
      redirectUri: request.redirectUri,
    };
    try {
      const response = await getFirebaseHelper().callCloudFunction(
        ZensoryCloudFunctionNames.InitMicrosoftOAuth,
        payload
      );
      return response;
    } catch (error) {
      LOGGER.log(
        LogLevel.ERROR,
        `login Calender error ${JSON.stringify(error)}`
      );
    }
  }

  async exchangeOAuthCode(request: {
    clientId: string;
    code: string;
    userId: string;
    redirectUri: string;
  }): Promise<any> {
    const payload = {
      clientId: request.clientId,
      code: request.code,
      userId: request.userId,
      redirectUri: request.redirectUri,
    };
    try {
      const response = await getFirebaseHelper().callCloudFunction(
        ZensoryCloudFunctionNames.ExchangeOAuthCode,
        payload
      );
      return response;
    } catch (error) {
      LOGGER.log(LogLevel.ERROR, `OAuthCode error ${JSON.stringify(error)}`);
      throw new Error(
        "Sorry. Unable to update interstitial settings right now. Please try again later."
      );
    }
  }

  async getCalenderschedule(request: {
    userId: string;
  }): Promise<any> {
    const payload = {
      userId: request.userId,
    };
    try {
      const response = await getFirebaseHelper().callCloudFunction(
        ZensoryCloudFunctionNames.getUserCalendarSchedule,
        payload
      );
      return response;
    } catch (error) {
      LOGGER.log(
        LogLevel.ERROR,
        `get Calender Schedule error ${JSON.stringify(error)}`
      );
    }
  }
  async createCalenderschedule(request: {
    userId: string;
    session: {
      startTime: string;
      sessionType: string;
      duration: number;
    };
  }): Promise<any> {
    try {
      const response = await getFirebaseHelper().callCloudFunction(
        ZensoryCloudFunctionNames.createCalenderSchedule,
        request
      );

      LOGGER.log(
        LogLevel.DEBUG,
        `Calender Create Schedule :::>>> response=${JSON.stringify(response)}`
      );
      return response;
    } catch (error) {
      LOGGER.log(
        LogLevel.ERROR,
        `Create Calender Schedule error ${JSON.stringify(error)}`
      );
    }
  }

  async updateCalenderschedule(request: {
    userId: string;
    events: Events[];
  }): Promise<any> {
    try {
      const response = await getFirebaseHelper().callCloudFunction(
        ZensoryCloudFunctionNames.updateCalenderSchedule,
        request
      );
      return response;
    } catch (error) {
      LOGGER.log(
        LogLevel.ERROR,
        `Calender Update Schedule error ${JSON.stringify(error)}`
      );
    }
  }
  async deleteCalenderschedule(request: {
    userId: string;
    eventId: string;
  }): Promise<any> {
    const payload = {
      userId: request.userId,
      eventId: request.eventId,
    };
    try {
      const response = await getFirebaseHelper().callCloudFunction(
        ZensoryCloudFunctionNames.deleteCalenderSchedule,
        payload
      );
      return response;
    } catch (error) {
      LOGGER.log(
        LogLevel.ERROR,
        `Calender Delete Schedule error ${JSON.stringify(error)}`
      );
    }
  }
}
